import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../../BASE_URL';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Documents.css';

const Documents = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchDocuments();
  }, []);

  const fetchDocuments = async () => {
    try {
      const response = await fetch(`${BASE_URL}/api/doc_verification`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('saptvidhiUserToken'),
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch documents');
      }

      const data = await response.json();
      setDocuments(data.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'approve':
        return '#22B00B';
      case 'reject':
        return '#FF0000';
      case 'pending':
        return '#FFA500';
      default:
        return '#FFA500';
    }
  };

  if (loading) {
    return (
      <div className="documents-container">
        <div className="loading">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="documents-container">
        <div className="error">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="documents-container">
      <h2 className="documents-title">Document Details</h2>
      {documents.length === 0 ? (
        <div className="no-documents">No documents uploaded yet</div>
      ) : (
        <div className="documents-grid">
          {documents.map((doc) => (
            <div key={doc._id} className="document-card">
              <div className="document-header">
                <h3>Document Type: {doc.doc_type}</h3>
                <div className="document-actions">
                  <span 
                    className="status-badge"
                    style={{ backgroundColor: getStatusColor(doc.status), color: '#FFFFFF' }}
                  >
                    {doc.status.toUpperCase()}
                  </span>
                  <button 
                    className={`update-btn ${doc.status.toLowerCase() === 'approve' ? 'disabled-btn' : ''}`}
                    onClick={() => {
                      if (doc.status.toLowerCase() === 'approve') {
                        toast.error('Cannot update approved documents', {
                          position: toast.POSITION.BOTTOM_RIGHT,
                          autoClose: 3000
                        });
                      } else {
                        navigate(`/document-update/${doc._id}`);
                      }
                    }}
                    disabled={doc.status.toLowerCase() === 'approve'}
                  >
                    Update Document
                  </button>
                </div>
              </div>
              <div className="document-images">
                <div className="image-container">
                  <h4>Front Side</h4>
                  <img 
                    src={doc.front_doc_photo} 
                    alt="Front Document" 
                    // onClick={() => window.open(doc.front_doc_photo, '_blank')}
                  />
                </div>
                <div className="image-container">
                  <h4>Back Side</h4>
                  <img 
                    src={doc.back_doc_photo} 
                    alt="Back Document" 
                    // onClick={() => window.open(doc.back_doc_photo, '_blank')}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default Documents;